module.exports = __webpack_public_path__ + "static/dent-d9206d95e2d748aa9938503c90d8edca.jpg";